<div class="arrow-down">
    <span class="icon icon-arrow-down" aria-hidden="true"></span>
</div>
